type CardProps = {
    id: string;
    children: React.ReactNode;
    className?: string;
};

export default function Card({ id, children, className = '' }: CardProps) {
    return (
        <div
            id={`${id}-card`}
            className={`shadow-[inset_2px_2px_5px_1px_#00000013] p-3 rounded-lg ${className}`}
        >
            {children}
        </div>
    );
}
